// Contains a membership and an event for Gary and a membership for Ashley
export const cartData = {
    "id":"157704",
    "member_id":95243,
    "items":[{
        "id":"187834",
        "product_type":"dues",
        "name":"DUESRM",
        "description":"Regular Member Dues",
        "price":250,
        "quantity":1,
        "tax":0,
        "tax_description":"",
        "member_id":95243,
        "meta_info":{
            "member_id":95243,
            "product_id":"1183b4ea-9d5f-ec11-8f8f-002248259b5e",
            "member_name":"Gary Rappaport",
            "company_name":"Rappaport",
            "dues_eligibility":{
                "one_year_pac":{
                    "id":null,
                    "selected":false
                },
                "one_year_sic":{
                    "id":"cf68ae99-d4d8-ea11-a817-000d3a579c89",
                    "selected":false
                },
                "three_year_pac":{
                    "id":null,
                    "selected":false
                },
                "three_year_sic":{
                    "id":"9dae209f-d4d8-ea11-a813-000d3a579c8c",
                    "selected":false
                },
                "one_year_membership":{
                    "id":"1183b4ea-9d5f-ec11-8f8f-002248259b5e",
                    "selected":true
                },
                "three_year_membership":{
                    "id":"4bec83ee-9d5f-ec11-8f8f-002248259aae",
                    "selected":false
                }
            }
        },
        "product_id":"1183b4ea-9d5f-ec11-8f8f-002248259b5e",
        "complimentary":false,
        "discounts":[],
        "prompts":[],
        "subtotal":250
    },{
        "id":"187835",
        "product_type":"event_fee",
        "name":"1202FP",
        "description":"ICSC@Red River Full Program",
        "price":750,
        "quantity":1,
        "tax":0,
        "tax_description":"",
        "member_id":95243,
        "meta_info":{
            "event_id":"67239f6e-bb3e-4b6f-b977-de10e6824a00",
            "member_id":95243,
            "event_code":"2023RRS",
            "event_name":"ICSC@RED RIVER",
            "product_id":"c5844c9f-4351-ed11-bba1-000d3a9bcaf2",
            "member_name":"Gary Rappaport",
            "company_name":"",
            "event_locale":"US",
            "event_function_code":"FP",
            "event_function_title":"Full Program",
            "event_fee_auto_enroll":true,
            "event_registrant_class":"M"
        },
        "product_id":"c5844c9f-4351-ed11-bba1-000d3a9bcaf2",
        "complimentary":false,
        "discounts":[],
        "prompts":[],
        "subtotal":750
    },{
        "id":"187836",
        "product_type":"dues",
        "name":"DUESRMA",
        "description":"Regular Affiliate Member Dues",
        "price":250,
        "quantity":1,
        "tax":0,
        "tax_description":"",
        "member_id":563086,
        "meta_info":{
            "member_id":563086,
            "product_id":"3691b1f0-9d5f-ec11-8f8f-002248259b5e",
            "member_name":"Ashley Abdool",
            "company_name":"Rappaport",
            "dues_eligibility":{
                "one_year_pac":{
                    "id":null,
                    "selected":false
                },
                "one_year_sic":{
                    "id":"acae209f-d4d8-ea11-a813-000d3a579c8c",
                    "selected":false
                },
                "three_year_pac":{
                    "id":null,
                    "selected":false
                },
                "three_year_sic":{
                    "id":"7488d9a4-d4d8-ea11-a813-000d3a579c8a",
                    "selected":false
                },
                "one_year_membership":{
                    "id":"3691b1f0-9d5f-ec11-8f8f-002248259b5e",
                    "selected":true
                },
                "three_year_membership":{
                    "id":"563aeaf6-9d5f-ec11-8f8f-002248259b5e",
                    "selected":false
                }
            }
        },
        "product_id":"3691b1f0-9d5f-ec11-8f8f-002248259b5e",
        "complimentary":false,
        "discounts":[],
        "prompts":[],
        "subtotal":250
    }],
    "order":{
        "id":"437768",
        "credit_card_token":null,
        "credit_card_type":null,
        "credit_card_last_four":null,
        "credit_card_expiration_date":null,
        "credit_card_first_name":null,
        "credit_card_last_name":null,
        "credit_card_zip":null,
        "billing_address_1":null,
        "billing_address_2":null,
        "billing_address_3":null,
        "billing_city":null,
        "billing_state_province":null,
        "billing_zip":null,
        "billing_country":null,
        "shipping_address_1":null,
        "shipping_address_2":null,
        "shipping_address_3":null,
        "shipping_city":null,
        "shipping_state_province":null,
        "shipping_zip":null,
        "shipping_country":null,
        "completed_at":null,
        "authorization_code":null,
        "transaction_code":null,
        "cart_id":"157704",
        "tax":0
    },
    "company_credit":0,
    "member_credit":0,
    "event_credit":0,
    "promotional_code":null,
    "promotional_discount":null,
    "promotional_discount_description":null,
    "total":1250,
    "locale":"US",
    "payment_intent":{
        "client_secret":"pi_3MWRMNEboZMA8jKT0zITBZvp_secret_m5K5DBYf3uDstf0hWcUrHg7MK",
        "amount":1250
    },
    "errors":[],
    "available_company_credit":0,
    "available_member_credit":249,
    "available_event_credit":0
};